module.exports = __webpack_public_path__ + "static/media/display-2.c2d41184.png";